import { inject } from '@angular/core';
import { CanActivateFn, Router, UrlTree } from '@angular/router';
import { AuthService } from '../services/auth.service';
import { sanitizeReturnUrl } from '../utils/url-sanitizer';
import { safeSessionStorageSet } from '../utils/safe-storage';

/**
 * Auth guard to protect routes that require authentication
 */
export const authGuard: CanActivateFn = async (route, state): Promise<boolean | UrlTree> => {
  const authService = inject(AuthService);
  const router = inject(Router);

  // Wait for async auth initialization (MSAL / local token restore) before checking
  await authService.waitForInitialization();

  if (authService.isAuthenticated()) {
    return true;
  }

  // Sanitize return URL before storing to prevent open redirect attacks
  const safeReturnUrl = sanitizeReturnUrl(state.url);
  
  // Save return URL in session storage for redirect after login
  safeSessionStorageSet('returnUrl', safeReturnUrl);

  // Return a UrlTree to avoid navigation race conditions
  return router.createUrlTree(['/login'], {
    queryParams: { returnUrl: safeReturnUrl }
  });
};
